class Controller {
  constructor(Sections) {
    "ngInject";

    this.sections = Sections.fleetSections;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/fleet/fleet.controller.js